import { Container, Divider, useMediaQuery } from '@material-ui/core'
import GetAppIcon from '@material-ui/icons/GetApp'
import React, { useEffect } from 'react'
import FlexView from 'react-flexview/lib'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'
import { SessionContextStore } from '../../../context/SessionContext'
import DataLayerService from '../../../services/DataLayerService'
import { EventEmitterService, EventKey } from '../../../services/EventEmitterService'
import { BackButton } from '../../Core/Buttons/BackButton'
import { CustomizeCoverages } from '../Coverages/CustomizeCoverages'
import { DatePlanSummary } from './Sections/DatePlanSummary'
import { BottomSheetPolicySummary } from '../BottomSheetPolicySummary'
import { SignRequiredPopup } from '../../PopUps/SignRequiredPopup'
import coveragesApi from '../../../api/coverages.api'
import AnalyticsApi from '../../../api/analytics.api'
import { awaitWithLoading } from '../../../services/utils'
import { RectangleFrame } from '../../Core/Frames/RectangleFrame'
import { useLocation } from 'react-router-dom'
import { reportGTM } from '../../Core/Utilities/GTagManger'
import { ReactComponent as DateSectionSvg } from '../../../assets/summary_date.svg'
import './Plans.scss'
import { BillingPlan } from './Sections/BillingPlan'
import { billing_period_options } from '../../../Constants'
import queryString from 'query-string'
import { CustomErrorPopup } from '../../PopUps/CustomErrorPopup'
import { getCookie } from '../../../utilities/cookies'

let classNames = require('classnames')

export const PlanSummary = () => {
  let location = useLocation()
  const offersContext = React.useContext(BuyingInsuranceContextStore)
  const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'))
  const [pdfs, setPdfs] = React.useState([])
  let isEditMode = location.state?.editMode !== undefined ? location.state.editMode : false
  const [editMode, setEditMode] = React.useState(isEditMode)
  const [showFooter, setshowFooter] = React.useState(true)
  const { OfferId } = queryString.parse(location.search)
  const [popUpErrorState, setPopUpErrorState] = React.useState({
    title: '',
    body: '',
    showPopUp: false,
  })
  const cancelErrorPopup = () => setPopUpErrorState({ open: false, title: '', body: '' })

  useEffect(() => {
    EventEmitterService.dispatch(EventKey.DismissLoader)
  }, [Object.keys(offersContext.offerCart).length !== 0])

  const onDateChanged = date => {
    offersContext.changeStartingDate(new Date(date))
  }

  const onDownloadPDF = async () => {
    if (Object.keys(offersContext.offerCardErrors).length > 0) {
      setPopUpErrorState({
        title: 'Invalid Quote',
        body: 'Please correct invalid fields before downloading your quote. Thank you.',
        showPopUp: true,
      })
      return
    }
    const event = { event: 'download-quote/summary-page' }
    DataLayerService.pushToDataLayer(event)

    const { data } = await awaitWithLoading(coveragesApi.getQuotePDF(offersContext.offerId))
    //const blob = await res.blob();
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(data)
    link.download = 'your_quote.pdf'
    link.click()
    link.remove()
  }

  const onContinue = async () => {
    const dateNow = new Date()
    dateNow.setHours(0, 0, 0, 0)
    if (offersContext.subscriptionStartTime < dateNow) {
      return
    }
    await awaitWithLoading(offersContext.updateCoverages())
    await awaitWithLoading(offersContext.updateQuoteData())
    //always create context so bind can validate nothing is missing
    const signaturesRes = await awaitWithLoading(
      coveragesApi.createDigitalSignatureDocs(offersContext.offerId, offersContext.offerCardWarnings.violationsId)
    )
    if (offersContext.offerCardWarnings.violationsId.length > 0) {
      // TODO: handle case of error
      setPdfs(signaturesRes.data)
      EventEmitterService.dispatch(EventKey.SIGN_REQUIERED_POPUP)
    } else {
      if (Object.keys(offersContext.offerCardErrors).length > 0) return
      const eventText = billing_period_options[offersContext.billingPeriod].gtm
      reportGTM('', '', { event: eventText })
      EventEmitterService.dispatch(EventKey.FLOW_SUMMARY_FINISH)
    }
    setshowFooter(false)
  }

  const onSignComplete = async signForm => {
    if (offersContext.userSignatureRequiredForBrokerPurchase()) {
      EventEmitterService.dispatch(EventKey.FLOW_SUMMARY_FINISH)
      const res = await awaitWithLoading(coveragesApi.sendDigitalSignatureSigningForm())
      return
    }
    const signature = signForm['signature']
    await awaitWithLoading(coveragesApi.saveDigitalSignature(signature))
    if (Object.keys(offersContext.offerCardErrors).length > 0) return
    EventEmitterService.dispatch(EventKey.FLOW_SUMMARY_FINISH)
    offersContext.dispatch({ type: 'SAVE_SIGNATURE', data: signature })
  }

  const goBack = () => {
    if (editMode) {
      setEditMode(!editMode)
    } else EventEmitterService.dispatch(EventKey.FLOW_GO_BACK)
  }

  const openPopup = () => {
    setEditMode(!editMode)
    if (!editMode) reportGTM('', '', { event: 'summary-page-clicked-edit-plan' })
    else reportGTM('', '', { event: 'summary-page-clicked-view-summary' })
  }

  useEffect(() => {
    if (OfferId != undefined && offersContext.plans && offersContext.plans.items.length > 0) {
      offersContext.getOfferById(OfferId, '/insurance/summary')
    }
  }, [OfferId, offersContext.plans])

  useEffect(() => {
    if (offersContext.plans.items.length === 0 && offersContext.plans.status === 'idle') {
      offersContext.loadPlans()
    }
  }, [offersContext.plans, offersContext.options])

  useEffect(() => {
    if (offersContext.shouldPassSummary) {
      onContinue()
      offersContext.passSummary(false)
    }
  }, [offersContext.shouldPassSummary])

  React.useEffect(() => {
    window.scrollTo(0, 0)
    AnalyticsApi.addUtmLog('quote', getCookie('page_full_url'))
  }, [])

  return (
    <>
      {Object.keys(offersContext.offerCart).length === 0 ? (
        <div>{EventEmitterService.dispatch(EventKey.ShowLoader)}</div>
      ) : (
        <>
          <Container className="margin-top-basic">
            <FlexView className="space-between full-width" vAlignContent={'center'}>
              <FlexView vAlignContent="center">
                <DateSectionSvg className="medium-icon" />
                <div className="text-title blue bold margin-left-8">Policy Details</div>
              </FlexView>
              <div className="download-quote-container bold blue avenir-book" onClick={onDownloadPDF}>
                <GetAppIcon />
                <span>Download Quote</span>
              </div>
            </FlexView>

            <Divider />

            {isMobile && showFooter && (Object.values(offersContext.plans.items[0]).length > 0 || offersContext.offerId) && (
              <BottomSheetPolicySummary title={'Continue'} onClick={onContinue} className="signature-footer" />
            )}

            <DatePlanSummary onDateChanged={onDateChanged} date={offersContext.subscriptionStartTime} />
            <Divider />
            {offersContext.billingPeriodEnabled && (
              <>
                <BillingPlan />
                <Divider />
              </>
            )}
            <CustomizeCoverages />
            <SignRequiredPopup onSignComplete={onSignComplete} pdfs={pdfs} />
            <CustomErrorPopup
              title={popUpErrorState.title}
              body={popUpErrorState.body}
              open={popUpErrorState.showPopUp}
              onCancel={cancelErrorPopup}
            />

            {/* {getWarnings() && <RectangleFrame>{getWarnings()}</RectangleFrame>} */}
            {Object.keys(offersContext.offerCardErrors).length > 0 && (
              <div className="text-body margin-bottom-basic red">In order to continue you must resolve the errors under Edit limits</div>
            )}
            {!isMobile && (
              <FlexView>
                <BackButton onClick={goBack} />
              </FlexView>
            )}
          </Container>
        </>
      )}
    </>
  )
}
